<template lang="pug">
  .year(@click="back()")
    //- h3 {{ year }}
    ul.events
      li(v-for="event in eventList")
        event-card-front(
          :event="event"
          :showYear="true"
          :showElement="true"
          )
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import EventCardFront from '@/components/EventCardFront'

export default {
  name: 'years',
  components: { EventCardFront },
  mounted() {
    this.listNumbers();
  },
  computed: {
    year() {
      return this.$route.params.id;
    },
    eventList() {
      const year = parseInt(this.year, 10);
      if (!year) {
        return [];
      }
      return this.events
        .filter(d => d.year === year)
        .map(event => {
          const number = this.numberByKey()(event.key);
          if (!number) {
            // eslint-disable-next-line no-console
            console.log('Missing number', event.key);
            return event;
          }
          event.number = number;
          event.symbol = number.data.symbol;
          return event;
        })

    },
    ...mapState('events', ['events'])
  },
  methods: {
    back() {
      this.$router.push({ name: 'year-list' });
    },
    ...mapActions('weekdays', ['listNumbers']),
    ...mapGetters('weekdays', ['numberByKey'])
  }
}
</script>

<style lang="stylus" scoped>
  @import "../../styles/card"

  .year
    position fixed
    top 0
    left 0
    height 100%
    width 100%
    background rgba(0, 0, 0, .5)
  .events
    list-style none
    margin 0 0 1rem
    padding 0
    display flex
    justify-content center
    height 100%
    align-items center
    li
      font-size .66rem
      margin .25rem
      & > div
        card-layout(20, 20)
</style>
